import { useReducer } from "react";
import createUseContext from "constate";

const getInitialState = () => ({
  currentWax: null,
  waxes: [],
  ratios: [],
  loading: false,
});

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_WAXES":
      return {
        ...state,
        waxes: action.payload,
      };
    case "SET_RATIOS":
      return {
        ...state,
        ratios: action.payload,
      };
    case "LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_HAS_ALERT": {
      return {
        ...state,
        waxes: state.waxes.map((w) => {
          if (w.id === Number(action.payload.id)) {
            w.has_alert = true;
          }

          return w;
        }),
      };
    }
    case "RESET":
      return action.payload;
    default:
      throw new Error("WaxSearchContext: action does not exist!");
  }
};

const useWaxes = () => {
  const [state, dispatch] = useReducer(reducer, getInitialState());
  const { waxes, ratios } = state;

  const setWaxes = (waxes) => {
    dispatch({
      type: "SET_WAXES",
      payload: waxes,
    });
  };

  const setRatios = (ratios) => {
    dispatch({
      type: "SET_RATIOS",
      payload: ratios,
    });
  };

  const reset = () => {
    dispatch({
      type: "RESET",
      payload: getInitialState(),
    });
  };

  const setLoading = (isLoading = false) => {
    dispatch({
      type: "LOADING",
      payload: isLoading,
    });
  };

  const setHasAlert = (id) => {
    dispatch({
      type: "SET_HAS_ALERT",
      payload: { id },
    });
  };

  return {
    waxes,
    ratios,
    setLoading,
    setWaxes,
    setRatios,
    reset,
    setHasAlert,
  };
};

const [WaxesProvider, useWaxesContext] = createUseContext(useWaxes);

export { WaxesProvider, useWaxesContext };
